var arrayLikeToArray = require("./arrayLikeToArray");

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles;


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/arrayWithoutHoles.js
// module id = 834
// module chunks = 1